<script setup>
import Input from 'dashboard/components-next/input/Input.vue';

defineProps({
  label: { type: String, default: '' },
  modelValue: { type: [String, Number], default: '' },
  type: { type: String, default: 'text' },
  placeholder: { type: String, default: '' },
  helpText: { type: String, default: '' },
  error: { type: String, default: '' },
  readonly: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'input', 'blur']);
</script>

<template>
  <Input
    :model-value="modelValue"
    :label="label"
    :type="type"
    :placeholder="placeholder"
    :readonly="readonly"
    :message="error || helpText"
    :message-type="error ? 'error' : 'info'"
    @update:model-value="emit('update:modelValue', $event)"
    @input="emit('input', $event)"
    @blur="emit('blur', $event)"
  >
    <template v-if="$slots.masked" #prefix>
      <slot name="masked" />
    </template>
  </Input>
</template>
